import { useTranslation } from '@mint-lib/i18n';
import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogOverlay,
  DialogRoot,
  DialogTitle,
  typographyVariants,
} from '@mint-lib/tw-components';

type RollbackProps = {
  isLoadingRollback: boolean;
  onClose: () => void;
  handleRevert: () => void;
};

const Rollback = ({
  isLoadingRollback,
  onClose,
  handleRevert,
}: RollbackProps) => {
  const { t } = useTranslation('@mint-lib/recommendations-circuit');

  return (
    <Dialog open modal>
      <DialogOverlay />
      <DialogRoot size={'s'}>
        <DialogHeader onClose={onClose}>
          <DialogTitle>{t('Rollback suggestion')}</DialogTitle>
        </DialogHeader>

        <DialogContent className="flex flex-col">
          <p
            className={typographyVariants({
              variant: 'bodyLong01',
            })}
          >
            {t(
              'By confirming this action you will be back to original suggestion and all the reworked changes will be lost',
            )}
          </p>
        </DialogContent>
        <DialogFooter className="flex flex-row gap-2">
          <Button
            onClick={onClose}
            variant="plain"
            className="p-3"
            size="large"
          >
            {t('Cancel')}
          </Button>
          <Button
            onClick={handleRevert}
            variant="contained"
            size="large"
            disabled={isLoadingRollback}
          >
            {t('Submit')}
          </Button>
        </DialogFooter>
      </DialogRoot>
    </Dialog>
  );
};

export default Rollback;
